<template>

<div class="bg-color-1">
<b-container>
<div class="row">


    <b-col class="my-5" lg="6" md="12" sm="12">
     <h4 class="font-weight-bold color-2"><b-icon icon="calendar4-week" class="mx-2 text-dark"/>12 دی 1400</h4>
     <h1 class="text-size-1">رویدادها, جلسات و</h1>
     <h1 class="text-size-1 color-3 mb-5">کنفرانس</h1>
     <span class="mx-3"><b-icon icon="diagram3" class="mx-2 text-danger"/><b class="mx-1">500</b>صندلی</span>
     <span class="mx-3"><b-icon icon="volume-up" class="mx-2 text-danger"/><b class="mx-1">10</b>سخنران</span>
     <span class="mx-3"><b-icon icon="joystick" class="mx-2 text-danger"/>ایران یزد خیابان مطهری</span><br>

     <a href="#"><b-button class="style-2">رزرو</b-button><br></a>
     <a href="#"><b-button class="style-33">دیدن جزئیات</b-button></a>
     
     
    </b-col>

    <b-col class="my-5" lg="6" md="12" sm="12">
     <img src="https://picsum.photos/400/400" alt="photo" class="w-100"/>
      </b-col>


  </div>
</b-container>

</div>

</template>

<script>
export default {
    name:"S503",

};
</script>

<style scoped>

h1 {
  color: black;
}

.menu-1 {
  margin-right: 350px;
}

.Place-Badges{
   position: absolute;
  left: 15px;
  top: 1px;
 }

 .font-1 {
   font-size: 60px;
 }

 .font-2 {
   font-size: 60px;
 }

 .font-3 {
   font-size: 25px;
 }

 .cart-1 {
   margin: 5px;
   color: rgb(234, 238, 238);
 }

.add-style-text:hover {
  background-color:rgb(221, 138, 14) !important;
  color:black;
}

.style-card {
  border: 20px;
}
.style-2 {
  background-color: var(--light-red);
  color: var(--light);
  font-weight: bold;
  border:2px solid var(--light-red);
  width: 110px;
  padding: 10px;
  margin-top: 50px;
  margin-right: 20px;
  transition: 0.5s;
}
.style-2:hover {
background-color: var(--light-danger) !important;
color: var(--light-red);
border:2px solid var(--light-red);
}
.style-33 {
 background-color: var(--light-danger) !important;
color: var(--light-red);
border:2px solid var(--light-red);
margin-right: 20px;
margin-top: 50px;
width: 170px;
padding: 10px;
font-weight: bold;
}
.style-33:hover {
 background-color: var(--light-red) !important;
  color: var(--light); 
}

</style>